var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"sign-page-content mt-1 page-container",attrs:{"fluid":""}},[_c('img',{attrs:{"src":_vm.logo,"width":"70px"}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }